const DraftList = ({
  drafts,
  onSelect
}) => {
  if (!drafts.length) {
    return (
      <div style={{ padding: 20 }}>
        No drafts.
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          padding: 20,
          fontWeight: 600,
          borderBottom:
            "1px solid #e0e0e0"
        }}
      >
        Drafts
      </div>

      {drafts.map((draft) => (
        <div
          key={draft.id}
          onClick={() => onSelect(draft)}
          style={{
            padding: "16px 20px",
            borderBottom:
              "1px solid #f0f0f0",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              fontWeight: 600
            }}
          >
            {draft.toEmail ||
              "(No recipient)"}
          </div>

          <div
            style={{
              color: "#666",
              marginTop: 4
            }}
          >
            {draft.subject ||
              "(No subject)"}
          </div>

          <div
            style={{
              color: "#888",
              marginTop: 6,
              whiteSpace:
                "nowrap",
              overflow: "hidden",
              textOverflow:
                "ellipsis"
            }}
          >
            {draft.message}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DraftList;